import { render, staticRenderFns } from "./capture-log.vue?vue&type=template&id=633bfa27&"
import script from "./capture-log.vue?vue&type=script&lang=js&"
export * from "./capture-log.vue?vue&type=script&lang=js&"
import style0 from "./capture-log.vue?vue&type=style&index=0&id=633bfa27&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports